const PictViewClass = require('pict-view');

/** @typedef {import('./HeadlightPanels-View.js').Pict} Pict */

class ProjectFileSearch extends PictViewClass
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;

		this.initialSearchResultsLoaded = false;

		this.DefaultSearchFilters = {
			IDCustomer: null,
			Projects: [],
			SearchText: '',
			PageSize: 25,
			CurrentPage: 1,
			TotalPages: 1,
			SortBy: 'Date',
			SortDirection: 'DESC',
		};
		this.CurrentProjectSelection = this.AppData?.DocumentData?.ReportData?.IDProject || null;
		this.CurrentProjectName = this.AppData?.DocumentData?.ReportData?.Project?.Name || null;
		this.CurrentSearchFilters = JSON.parse(JSON.stringify(this.DefaultSearchFilters));
		this.CurrentSearchFiltersCount = 0;
		this.CurrentSearchResults = [];
		this.CurrentFolderName = '';
		this.selectedObservation = {};
		this.ObservationTypeManifest = [];
		this.SearchPanelMode = '';
		this.SelectedFileFolder = null;
		this.SelectedFileFolderName = '';

		// TODO: We need to get this from the server from configured types by IDProgram
		// TODO: We also need a default set configured for Headlight
		this.FileTypes = [
			{ id: '', text: 'Select a type', disabled: true },
			{ id: 'Calculations', text: 'Calculations' },
			{ id: 'Images', text: 'Images' },
			{ id: 'Inspection Report', text: 'Inspection Report' },
			{ id: 'Load Rating', text: 'Load Rating' },
			{ id: 'Miscellaneous', text: 'Miscellaneous' },
			{ id: 'Plan', text: 'Plan' },
			{ id: 'Scour', text: 'Scour' },
			{ id: 'Structural Inventory and Appraisal', text: 'Structural Inventory and Appraisal' },
			{ id: 'Unknown', text: 'Unknown' },
			{ id: 'Custom', text: 'Custom' },
		];
	}

	onBeforeRenderAsync(pCallback)
	{
		this.CurrentSearchFilters.IDCustomer = this.AppData?.DocumentData?.ReportData?.IDCustomer || this.AppData?.CurrentUser?.CustomerID || 0;
		if (pCallback)
		{
			pCallback();
		};
	}

	async onAfterRenderAsync(pCallback)
	{
		const elementID = 'ProjectFileSearch-Projects';
		// PROJECT Selector Filter
		// if we have a project already, make it sticky on the top of the list

		// Bridge App has no DocumentData but exposes the active project on AppData.BridgeProject
		const tmpDefaultIDProject = this.AppData?.DocumentData?.ReportData?.IDProject || this.AppData?.BridgeProject?.IDProject;
		const tmpDefaultProjectName = this.AppData?.DocumentData?.ReportData?.Project?.Name || this.AppData?.BridgeProject?.Name;

		const tmpProject = this.CurrentSearchFilters?.Projects.length === 0 ?
			(tmpDefaultIDProject ? { id: tmpDefaultIDProject, text: tmpDefaultProjectName } : null ) :
			{ id: this.CurrentProjectSelection || tmpDefaultIDProject, text: this.CurrentProjectName || tmpDefaultProjectName };

		this.initializeSelect2Plugin({
			dropdownCssClass: 'theme-dark' + (tmpProject ? ' has-sticky-option' : ''),
			placeholder: 'Search by projects...',
			ElementID: elementID,
			ParentID: 'ProjectFileSearch-SearchEntry',
			IDCustomer: this.CurrentSearchFilters?.IDCustomer,
			URL: 'Projects',
			IDField: 'IDProject',
			TextField: 'Name',
			StickyOption: tmpProject,
		}, () =>
		{
			this.log.info('Select2 Projects initialized');
		});

		this.setCurrentSearchFilters();
		//if we don't have search results, perform a search
		if (!this.initialSearchResultsLoaded)
		{
			//handle a preselected option if it exists
			if (tmpProject.id && tmpProject.id > 0)
			{
				//moved this out of the initialization to allow for the select2 change event to trigger after the initial load
				const select2 = $(`#${elementID}`);
				// create the option and append to Select2
				const option = new Option(tmpProject.text, tmpProject.id, true, true);
				select2.append(option).trigger('change');

				// manually trigger the `select2:select` event
				select2.trigger(
				{
					type: 'select2:select',
					params:
					{
						data: tmpProject,
					},
				});
			}
			this.initialSearchResultsLoaded = true;
			this.handleProjectFileSearch();
		}

		// if project container exists
		if (document.getElementById('ProjectFileSearch-Project-Container'))
		{
			// if we have a project, show it
			if (tmpDefaultIDProject)
			{
				document.getElementById('ProjectFileSearch-Project-Selected').classList.remove('is-hidden');
			}
			// if we don't have a project, show empty project id container
			else
			{
				document.getElementById('ProjectFileSearch-Project-Empty').classList.remove('is-hidden');
			}
		}
		this.toggleAllSectionVisibility('open');
		if (pCallback) pCallback();
	}

	/**
	 * This method performs an observation search based on the current search filters.
	 * @param {Event} [event] - The event that triggered the search.
	 * @param {string} [pRowID] - The ID of the row to search for.
	 * @param {boolean} [pIsChild] - Whether the search is for a child file or folder.
	 * @return {Promise<void>}
	 * @async
	 */
	async handleProjectFileSearch(event, pRowID, pIsChild)
	{
		// prevent the browser from refreshing on form submissions
		if (event)
		{
			event.preventDefault();
		}
		// add the loading spinner on the button when the action is being performed
		this.pict.ContentAssignment.addClass('#ProjectFileSearch-SearchButton', 'is-loading');
		// simulate that data is loading in the results table
		this.pict.views.HeadlightPanels.addLoadingSkeletonRows('ProjectFileSearch-Results-Container', this.CurrentSearchFilters.PageSize, '6rem');
		// toggle the filter panel closed
		this.pict.views.HeadlightPanels.toggleCollapsiblePanelBlockGroup('ProjectFileSearchFilters', 'close');
		// perform the project file search
		await this.pict.providers.ProjectFileProvider.getProjectFilesDataStructure(this.CurrentProjectSelection, this.CurrentSearchFilters, (/** @type {any} */ pResult) =>
		{
			if (!Array.isArray(pResult))
			{
				// Render search results template (non-blocking, no side effects here)
				this.pict.views.ProjectFileSearch.renderAsync('ProjectFileSearch-Results', '#ProjectFileSearch-Results-Container', false, () =>
				{
					try
					{
							this.pict.ContentAssignment.removeClass('#ProjectFileSearch-SearchButton', 'is-loading');

							if (this.ProjectFileSearchResultsCallback)
							{
								// eslint-disable-next-line new-cap
								this.ProjectFileSearchResultsCallback(this.CurrentSearchResults);
							}
					}
					catch (innerError)
					{
							this.pict.log.error('Error in renderAsync callback:', innerError);
					}
				},
				);
			}
			else
			{
				this.updateWithSearchResults(pResult, pRowID, pIsChild);
			}
		});
	}

	/**
	 * This method initializes the select2 plugin.
	 * @param {Object} pOptions - The options to use for initialization.
	 * @param {Function} pCallback - The callback function to execute after initialization.
	 * @return {void}
	 */
	initializeSelect2Plugin(pOptions, pCallback)
	{
		$('#' + pOptions.ElementID).select2({
			dropdownParent: $('#' + pOptions.ParentID),
			dropdownCssClass: pOptions.dropdownCssClass || 'theme-dark',
			/* @ts-ignore */
			selectionCssClass: pOptions.selectionCssClass || 'theme-dark',
			placeholder: pOptions.placeholder || 'Select...',
			minimumInputLength: pOptions.minimumInputLength > -1 ? pOptions.minimumInputLength : this.pict.views.HeadlightPanels.MinimumInputLengthForSearch,
			language: {
				searching: function()
				{
					return pOptions.searchingMessage || 'Searching...';
				},
				noResults: function()
				{
					return pOptions.noResultsMessage || 'No results found.';
				},
				loadingMore: function()
				{
					return pOptions.loadingMoreMessage || 'Loading more results...';
				},
				inputTooShort: function(args)
				{
					return pOptions.inputTooShortMessage || 'Please enter at least ' + args.minimum + ' characters to see results.';
				},
			},
			ajax: {
				xhrFields: {
					withCredentials: true,
				},
				dataType: 'json',
				method: 'GET',
				url: function(params)
				{
					const tmpSearchQuery = {
						filters: [ {
							field: 'IDCustomer',
							comparator: 'EQ',
							target: pOptions.IDCustomer || 0,
						} ],
						pagination: {
							start: pOptions?.CurrentPage || 1,
							limit: pOptions?.PageSize || 25,
						},
					};
					// add the search term to the query if it exists
					if (params.term)
					{
						tmpSearchQuery.filters.push({
							field: pOptions.TextField,
							comparator: 'LK',
							target: params.term,
						});
					}
					const startCount = (tmpSearchQuery.pagination.start - 1) * tmpSearchQuery.pagination.limit;
					const endCount = tmpSearchQuery.pagination.start * tmpSearchQuery.pagination.limit;
					return `/1.0/${pOptions.URL}/${_Pict.providers.UtilityProvider.generateMeadowFilter(tmpSearchQuery)}/${startCount}/${endCount}`;
				},
				processResults: function(data, params)
				{
					params.page = params.page || 1;

					const tmpSelections = _Pict.views.ProjectFileSearch.CurrentSearchFilters[pOptions.URL] || [];

					return {
						results: _Pict.providers.UtilityProvider.formatSelect2Results(data, pOptions.IDField, pOptions.TextField, tmpSelections, pOptions.StickyOption),
						more: params.term ? data.length === _Pict.views.ProjectFileSearch.CurrentSearchFilters.PageSize : data.length === _Pict.views.ProjectFileSearch.CurrentSearchFilters.PageSize,
					};
				},
			},
		});

		// call the callback function if it exists
		if (pCallback)
		{
			pCallback();
		}
	}

	/**
	 * This method resets the search filters to an empty state.
	 * @return {void}
	 */
	resetSearchFilters()
	{
		// reset the search filters to the default state
		this.CurrentSearchFilters = JSON.parse(JSON.stringify(this.DefaultSearchFilters));
		this.setCurrentSearchFiltersCount();
		this.handleProjectFileSearch();
	}

	/**
	 * This method initializes the view and sets the default search filters.
	 * @param {object} pSearchFilters - The search filters to set.
	 * @return {void}
	 * @example
	 * setCurrentSearchFilters({Projects: [1234], ObservationTypes: ['Legacy Narrative'], SearchText: 'dog'})
	 */
	setCurrentSearchFilters(pSearchFilters)
	{
		// set the search filters to the passed in filters
		if (pSearchFilters)
		{
			this.CurrentSearchFilters = Object.assign(JSON.parse(JSON.stringify(this.DefaultSearchFilters)), pSearchFilters);
		}
		// if the search entry form exists (is actively the rendered panel), stuff the values into the form
		if (document.getElementById('ProjectFileSearch-SearchEntry'))
		{
			// for each filter, also stuff the values into the search form.
			this.pict.ContentAssignment.assignContent('#ProjectFileSearch-Projects', this.CurrentSearchFilters?.Projects);
			this.pict.ContentAssignment.assignContent('#ProjectFileSearch-SearchText', this.CurrentSearchFilters?.SearchText || '');
			this.pict.ContentAssignment.assignContent('#ProjectFileSearch-SearchFolder', this.CurrentSearchFilters?.SearchFolder || '');
			this.pict.ContentAssignment.assignContent('#ProjectFileSearch-CurrentPage', this.CurrentSearchFilters?.CurrentPage || 1);
			this.pict.ContentAssignment.assignContent('#ProjectFileSearch-PageSize', this.CurrentSearchFilters?.PageSize || 25);
		}
		this.setCurrentSearchFiltersCount();
	}

	/**
	 * This method sets the current search filters count on the 'Set Filters' button.
	 * @return {void}
	 */
	setCurrentSearchFiltersCount()
	{
		this.CurrentSearchFiltersCount = 0;
		const my = this.CurrentSearchFilters;

		if (my.Projects && my.Projects.length > 0)
		{
			this.CurrentSearchFiltersCount += my.Projects.length;
		}
		if (my.SearchText && my.SearchText.length > 0)
		{
			this.CurrentSearchFiltersCount += 1;
		}
		if (my.StartDate)
		{
			this.CurrentSearchFiltersCount += 1;
		}
		if (my.EndDate)
		{
			this.CurrentSearchFiltersCount += 1;
		}
	}

	/**
	 * Set the callback function for the search results.
	 * @param {Function} pCallback - The callback function to set.
	 * @return {void}
	 * @example
	 * setProjectFileSearchResultsCallback((pResults) => { console.log(pResults); });
	 */
	setProjectFileSearchResultsCallback(pCallback)
	{
		// TODO: not sure if this is the best way to handle this, but it works for now.
		this.ProjectFileSearchResultsCallback = pCallback;
	}

	/**
	 * Updates the search filter value based on the event and filter type.
	 * @param {string} pFilterType - The type of filter to update.
	 * @return {void}
	 * @example
	 * updateSearchFilterValue('Project');
	 */
	updateSearchFilterValue(pFilterType)
	{
		switch (pFilterType)
		{
		case 'Project':
		case 'Projects':
			this.CurrentProjectSelection = /** @type {HTMLSelectElement} */ (document.getElementById('ProjectFileSearch-Projects')).value;
			this.CurrentProjectName	 = /** @type {HTMLSelectElement} */ (document.getElementById('ProjectFileSearch-Projects')).options[/** @type {HTMLSelectElement} */ (document.getElementById('ProjectFileSearch-Projects')).selectedIndex].text;
			this.CurrentSearchFilters.Projects = this.pict.ContentAssignment.readContent('#ProjectFileSearch-Projects');
			break;
		case 'SearchText':
			this.CurrentSearchFilters.SearchText = this.pict.ContentAssignment.readContent('#ProjectFileSearch-SearchText');
			break;
		case 'SearchFolder':
			this.CurrentSearchFilters.SearchFolder = this.pict.ContentAssignment.readContent('#ProjectFileSearch-SearchFolder');
			break;
		default:
			this.log.error(`Unknown filter type: ${pFilterType}`);
		}
		this.setCurrentSearchFiltersCount();
	}

	/**
	 * This method updates the search results/UI based on the search results and total search count passed in.
	 * @param {Array} pSearchResults - The search results to update with.
	 * @param {string} [pRowID] - The ID of the row to update.
	 * @param {boolean} [pIsChild] - Whether the row is a child row.
	 * @return {void}
	 */
	updateWithSearchResults(pSearchResults, pRowID, pIsChild)
	{
		try
		{
			this.CurrentSearchResults = pSearchResults;
			const pTotalSearchCount = pSearchResults.length;

			// Calculate pagination pages - doesn't really apply to Project File Search, but keeping for future enhancements (sort, filter, etc.)
			this.CurrentSearchFilters.TotalPages = Math.ceil(pTotalSearchCount / this.CurrentSearchFilters.PageSize);

			// Render search results template (non-blocking, no side effects here)
			this.pict.views.ProjectFileSearch.renderAsync(
				'ProjectFileSearch-Results',
				'#ProjectFileSearch-Results-Container',
				false,
				() =>
				{
					try
					{
						this.pict.ContentAssignment.removeClass('#ProjectFileSearch-SearchButton', 'is-loading');

						if (this.ProjectFileSearchResultsCallback)
						{
							// eslint-disable-next-line new-cap
							this.ProjectFileSearchResultsCallback(this.CurrentSearchResults);
						}

						// Delay scroll to ensure DOM is patched
						requestAnimationFrame(() =>
						{
							this._tryScrollToRow(pRowID, pIsChild);
						});
					}
					catch (innerError)
					{
						this.pict.log.error('Error in renderAsync callback:', innerError);
					}
				},
			);
		}
		catch (outerError)
		{
			this.pict.log.error('Failed to update with search results:', outerError);
		}
	}

	/**
	* Smoothly scrolls to a row inside a scrollable container using jQuery.
	* @param {string} pRowID - The row ID to scroll to.
	* @param {boolean} pIsChild - Whether the row is a child row.
	* @param {number} [offset=70] - Offset in pixels from the top of the container.
	* @param {string} [containerSelector='#ProjectFileSearch-Results-Container'] - The scrollable container selector.
	*/
	_tryScrollToRow(pRowID, pIsChild, offset = 70, containerSelector = '#HeadlightPanels-ProjectFileSearch-Content')
	{
		if (!pRowID)
		{
			return;
		}

		const $container = $(containerSelector);
		if ($container.length === 0)
		{
			this.pict.log.warn(`Scroll container "${containerSelector}" not found.`);
			return;
		}

		const elID = pIsChild ?
		`ProjectFileSearch-Results-Treeview-Child-${pRowID}` :
		`ProjectFileSearch-Results-Treeview-${pRowID}`;

		const maxAttempts = 10;
		let attempt = 0;
		const interval = 100;

		const tryScroll = () =>
		{
			const $el = $(`#${elID}`);
			if ($el.length > 0)
			{
			// Offset of element and container from document
				const containerOffset = $container.offset().top;
				const elOffset = $el.offset().top;

				// Calculate scrollTop relative to container's current scroll
				const relativeScrollTop = $container.scrollTop() + (elOffset - containerOffset - offset);

				$container.animate({ scrollTop: relativeScrollTop }, 400);

				$el.addClass('highlight');
				setTimeout(() => $el.removeClass('highlight'), 5000);
			}
			else if (attempt++ < maxAttempts)
			{
				setTimeout(tryScroll, interval);
			}
			else
			{
				this.pict.log.warn(`Row with ID "${elID}" not found after ${maxAttempts} attempts.`);
			}
		};

		setTimeout(tryScroll, interval);
	}


	/**
	 * @spec puts a loading spinner on the element for a short time: 1.5 seconds.
	 * @param {HTMLElement} htmlElement
	 */
	animateLoading(htmlElement)
	{
		htmlElement.classList.add('is-loading');
		setTimeout(() => htmlElement.classList.remove('is-loading'), 1500);
	}

	/**
	 * This method handles the Details button click for an observation.
	 * @param {Event} pEvent - The event that triggered the click.
	 * @param {number} pIDObservation - The ID of the observation to view details for.
	 * @return {Promise<void>}
	 * @async
	 */
	async handleProjectFilesDetailsClick(pEvent, pIDObservation)
	{
		if (pEvent && pEvent.currentTarget instanceof HTMLElement)
		{
			this.animateLoading(pEvent.currentTarget);
		}
		// get the observation from the server
		const tmpObservation = await this.pict.providers.ObservationProvider.getObservationByID(pIDObservation);
		this.log.info('Observation to pull the file from:', tmpObservation);
		// and go to the observation detail view for the new observation
		this.pict.views.ObservationDetails.ActiveObservationDetails = tmpObservation;
		this.pict.views.ObservationDetails.ObservationDetailsBackTo = 'ProjectFileSearch';
		this.pict.views.HeadlightPanels.handlePanelToggle('ObservationDetails', 'open');
	}

	/**
	 * This method handles the Clone button click for an observation.
	 * @param {Event} pEvent - The event that triggered the click.
	 * @param {number} pIDObservation - The ID of the observation to clone.
	 * @return {Promise<void>}
	 * @async
	 */
	async handleProjectFileCloneClick(pEvent, pIDObservation)
	{
		if (pEvent && pEvent.currentTarget instanceof HTMLElement)
		{
			pEvent.currentTarget.classList.add('is-loading');
		}
		// get the observation from the server
		const tmpObservation = await this.pict.providers.ObservationProvider.getObservationByID(pIDObservation);
		this.log.info('Observation to pull the file from:', tmpObservation);

		let tmpIDArtifact;
		let tmpVersion;
		// show a PDF viewer if the observation is a PDF file type
		if (tmpObservation?.Details?.File?.[0]?.Datum?.FileMimeType === 'application/pdf')
		{
			tmpIDArtifact = tmpObservation?.Details?.File?.[0]?.IDArtifact;
			tmpVersion = tmpObservation?.Details?.File?.[0]?.Version;
		}
		else
		{
			this.pict.views.HeadlightPanels.toast({
				message: 'The selected project file is not a PDF file and cannot be added to the document.',
				type: 'is-danger',
			});
			return;
		}
		// download the file off of the observation
		const tmpFile = await this.pict.providers.ObservationProvider.downloadFileFromObservation(tmpIDArtifact, tmpVersion);
		// create a temporary file object to pass to the observation provider
		const newObservationObject = {
			File: tmpFile,
			ObservationType: tmpObservation.ObservationType,
			Name: tmpObservation.Details.File[0].Datum.FileName,
		};
		// TODO: Make this convert the file to an observation and add it to the document
		// Create an observation from the file
		await this.pict.providers.ObservationProvider.prepareObservationObjectFromFile(newObservationObject, this.AppData?.DocumentData?.ReportData?.IDProject,
		(observationResult) =>
		{
			// remove the loading spinner from the button
			this.pict.providers.UtilityProvider.removeAllLoadingClasses();
			// join to the document, if we have one
			this.pict.providers.ObservationProvider.joinObservationToDocumentRecord(observationResult.IDObservation, this.AppData?.DocumentData?.ReportData?.IDDocument);
			const tmpObservations = this.AppData?.DocumentData?.ReportData?.Observations;
			// add result to our document if we have one
			if (tmpObservations && Array.isArray(tmpObservations))
			{
				tmpObservations.push(observationResult);
			}
			// if we have a set (we always should in this case), add the observation to the set
			if (this.pict.views.ObservationSet.ActiveObservationSet)
			{
				this.pict.views.ObservationSet.addObservationToSet(observationResult?.IDObservation);
			}
			// and go to the observation detail view for the new observation
			this.pict.views.ObservationDetails.ActiveObservationDetails = observationResult;
			this.pict.views.ObservationDetails.ObservationDetailsBackTo = 'ProjectFileSearch';
			this.pict.views.HeadlightPanels.handlePanelToggle('ObservationDetails', 'open');
		});
	}

	/**
	 * This method handles the Clone button click for an observation.
	 * @param {Event} pEvent - The event that triggered the click.
	 * @param {number} pIDObservation - The ID of the observation to clone.
	 * @return {Promise<void>}
	 * @async
	 */
	async handleProjectFileAddClick(pEvent, pIDObservation)
	{
		if (pEvent && pEvent.currentTarget instanceof HTMLElement)
		{
			pEvent.currentTarget.classList.add('is-loading');
		}
		// get the observation from the server
		const tmpObservation = await this.pict.providers.ObservationProvider.getObservationByID(pIDObservation);
		this.log.info('Observation to pull the file from:', tmpObservation);
		// remove the loading spinner from the button
		this.pict.providers.UtilityProvider.removeAllLoadingClasses();
		// join to the document, if we have one
		this.pict.providers.ObservationProvider.joinObservationToDocumentRecord(tmpObservation.IDObservation, this.AppData?.DocumentData?.ReportData?.IDDocument);
		const tmpObservations = this.AppData?.DocumentData?.ReportData?.Observations;
		// add result to our document if we have one
		if (tmpObservations && Array.isArray(tmpObservations))
		{
			tmpObservations.push(tmpObservation);
		}
		// if we have a set (we always should in this case), add the observation to the set
		if (this.pict.views.ObservationSet.ActiveObservationSet)
		{
			this.pict.views.ObservationSet.addObservationToSet(tmpObservation?.IDObservation);
		}
		// and go to the observation detail view for the new observation
		this.pict.views.ObservationDetails.ActiveObservationDetails = tmpObservation;
			this.pict.views.ObservationDetails.ObservationDetailsBackTo = 'ProjectFileSearch';
		this.pict.views.HeadlightPanels.handlePanelToggle('ObservationDetails', 'open');
	}

	/**
	 * Handles the change of file type in the dropdown.
	 * @param {HTMLSelectElement} selectEl - The select element that triggered the change.
	 * @param {string} fileID - The ID of the file whose type is being changed.
	 * @return {void}
	 */
	handleFileTypeChange(selectEl, fileID)
	{
		const customInput = /** @type {HTMLInputElement} */ (document.getElementById(`ProjectFileSearch-Results-Treeview-List-File-Type-Custom-${fileID}`));
		if (selectEl.value === 'Custom')
		{
			customInput.classList.remove('is-hidden');
			customInput.focus();
		}
		else
		{
			customInput.classList.add('is-hidden');
		}
	}

	/**
	 * Add a dropdown menu to the toggle button for a table row.
	 * @param {string} pDate - The date of the file.
	 * @param {string} pName - The name of the file.
	 * @param {string} pFileID - The IDFile of the file.
	 * @param {string} pRowID - The ID of the row.
	 * @param {string} pFileType - The Type of the file.
	 * @param {Event} event - The event that triggered the function.
	 * @return {void}
	 */
	// @ts-ignore
	// @ts-ignore
	projectFileEditHandler(event, pDate, pName, pFileID, pRowID, pFileType, pParentIDProjectFileFolder)
	{
		// this is to get any changes to the file name made outside of the EDIT modal
		const fileNameElement = /** @type {HTMLElement} */ (document.getElementById(this.getFileNameDisplayID(pRowID)));
		const fileName = fileNameElement ? fileNameElement.textContent.trim() : pName;
		// the body and footer templates for the confirmation modal
		const editModalBodyTemplate = /*html*/`
		<span id="EditModalBody">
			<div class="fixed-grid has-2-cols">
				<div class="grid">
					<div class="cell">
						<label class="label" for="ProjectFileSearch-Results-Treeview-List-Date">Create Date</label>
						<input type="text" class="input" disabled="disabled" id="ProjectFileSearch-Results-Treeview-List-Date" value="${pDate || 'Unknown Date'}" />
					</div>
					<div class="cell">
						<label class="label" for="ProjectFileSearch-Results-Treeview-List-File-Type-Select-${pFileID}">File Type</label>
						<p class="control select is-fullwidth is-relative">
							<select 
								id="ProjectFileSearch-Results-Treeview-List-File-Type-Select-${pFileID}" 
								class="input ml-auto mr-2"
								onchange="_Pict.views.ProjectFileSearch.handleFileTypeChange(this, ${pFileID})"
								title="Select File Type">
								${_Pict.views.ProjectFileSearch.renderFileTypeOptions(pFileType)}
							</select>
							<input type="text" class="input mt-2 is-hidden"
								id="ProjectFileSearch-Results-Treeview-List-File-Type-Custom-${pFileID}"
								placeholder="Enter custom file type" />
						</p>
					</div>
					<div class="cell is-col-span-2">
						<div class="control">
						<label class="label" for="ProjectFileSearch-Results-Treeview-List-File-Name-${pFileID}">File Name</label>
						<textarea class="textarea is-justify-content-left" rows="2" max-rows="2" id="ProjectFileSearch-Results-Treeview-List-File-Name-${pFileID}">${fileName}</textarea>
						</div>
					</div>
				</div>
			</div>
		</span>`;
		const editModalFooterTemplate = /*html*/`
		<div id="EditModalFooter" class="buttons is-right">
			<button class="button is-primary is-soft" type="button" title="Cancel Save" onclick="_Pict.fable.services.HeadlightModal.dismissModals()">
				<span class="icon">
					<i class="fas fa-fw fa-times" aria-hidden="true"></i>
				</span>
				<span>Cancel</span>
			</button>
			<button class="button is-primary" type="button" title="Save Project File" onclick="_Pict.views.ProjectFileSearch.projectFileSaveHandler(event, ${pFileID}, '${pRowID}', '${fileName}', '${pParentIDProjectFileFolder}')">
				<span class="icon">
					<i class="fas fa-fw fa-copy" aria-hidden="true"></i>
				</span>
				<span>Save</span>
			</button>
		</div>`;
		// the options for the edit modal
		const editModalOptions = {
			title: 'Edit Project File?',
			modalBodyTemplate: editModalBodyTemplate,
			modalFooterTemplate: editModalFooterTemplate,
			confirmText: 'Save',
			cancelText: 'Cancel',
		};
		this.fable.HeadlightModal.spawnModal(editModalOptions, this.confirmSaveCallback.bind(this));
	}

	getFileDisplayID(pRowID)
	{
		return `DISPLAY-FOR-${pRowID}`;
	}

	getFileNameDisplayID(pRowID)
	{
		return `NAME-FOR-${pRowID}`;
	}

	getFileEditID(pRowID)
	{
		return `EDIT-FOR-${pRowID}`;
	}

	getFileInputID(pRowID)
	{
		return `INPUT-FOR-${pRowID}`;
	}

	/**
	 * Switch between edit and display views for a given row.
	 * @param {*} pRowID The row id to switch modes for.
	 */
	projectFileRenameSwitchMode(pRowID)
	{
		// Swap out the display and the input
		const displayElement = document.getElementById(this.getFileDisplayID(pRowID));
		const editElement = document.getElementById(this.getFileEditID(pRowID));
		const inputElement = document.getElementById(this.getFileInputID(pRowID));
		if (displayElement.classList.contains('is-hidden'))
		{
			displayElement.classList.remove('is-hidden');
			editElement.classList.add('is-hidden');
		}
		else
		{
			displayElement.classList.add('is-hidden');
			editElement.classList.remove('is-hidden');
			inputElement.focus();
			// @ts-ignore
			inputElement.setSelectionRange(inputElement.value.length, inputElement.value.length);
		}
	}

	setProjectFileNameInCurrentSearchResults(pName, pIDProjectFile)
	{
		// Safer findParentNode
		function findNode(nodes, id)
		{
			if (!nodes || !Array.isArray(nodes)) return null;

			for (const node of nodes)
			{
				if (!node) continue; // skip undefined or null nodes
				if (node.ID === id) return node;
				if (node.Children && Array.isArray(node.Children) && node.Children.length > 0)
				{
					const found = findNode(node.Children, id);
					if (found) return found;
				}
			}
			return null;
		}

		const node = findNode(this.CurrentSearchResults, parseInt(pIDProjectFile));
		node.Name = pName;
	}

	/**
	 * Validates a file name against a set of rules.
	 * @param {string} pFileName - The file name to validate.
	 * @param {string} pParentIDProjectFileFolder - The parent folder ID for the file.
	 * @param {Array} [allowedExtensions=[]] - An array of allowed file extensions.
	 * @param {number} [maxLength=255] - The maximum allowed length for the file name.
	 * @return {boolean} - Returns true if the file name is valid, otherwise false.
	 */
	isValidFileName(pFileName, pParentIDProjectFileFolder, allowedExtensions = [], maxLength = 255)
	{
		const invalidCharsRegex = /[\\/:*?"<>|]/;
		const nameRegex = /^(.*)(\.[^.]+)$/; //if extension is provided

		if (!pFileName || pFileName.trim() === '')
		{
			this.pict.views.HeadlightPanels.toast({
				message: 'File name cannot be blank',
				type: 'is-danger',
			});
			return;
		}

		// Check for invalid characters
		if (invalidCharsRegex.test(pFileName))
		{
			this.pict.views.HeadlightPanels.toast({
				message: 'Filename contains invalid characters. Valid characters are alphanumeric, spaces, - _ .',
				type: 'is-danger',
				duration: 5000,
			});
			return false;
		}

		// The regex checks for at least one character before the dot and allows an optional extension after the dot.
		if (nameRegex.test(pFileName) === false)
		{
			this.pict.views.HeadlightPanels.toast({
				message: 'Filename is not valid. Valid format is name.extension.',
				type: 'is-danger',
				duration: 5000,
			});
			return false;
		}

		// db has name set to Char(255) so check for length
		if (pFileName.length > maxLength)
		{
			this.pict.views.HeadlightPanels.toast({
				message: `Filename exceeds maximum length of ${maxLength} characters.`,
				type: 'is-danger',
			});
			return false;
		}

		// Check for extension if allowedExtensions are provided
		if (allowedExtensions.length > 0)
		{
			const parts = pFileName.split('.');
			const extension = parts.pop().toLowerCase();
			if (!allowedExtensions.includes(extension))
			{
				this.pict.views.HeadlightPanels.toast({
					message: `Invalid file extension. Allowed extensions: ${allowedExtensions.join(', ')}`,
					type: 'is-danger',
				});
				return false;
			}
		}

		const checkFileName = this.checkFileNameExists(this.CurrentSearchResults, pFileName, pParentIDProjectFileFolder);
		if (checkFileName !== pFileName)
		{
			this.pict.views.HeadlightPanels.toast({
				message: 'A file with this name already exists in this folder',
				type: 'is-danger',
			});
			return false;
		}
		return true;
	}

	async projectFileRename(event, pName, pIDProjectFile, pParentIDProjectFileFolder, pRowID)
	{
		const inputElement = $(`#${this.getFileInputID(pRowID)}`);
		const newFileName = inputElement.val().toString();

		const hasFileNameChanged = pName !== newFileName;
		if (hasFileNameChanged)
		{
			const isValidFileName = this.isValidFileName(newFileName, pParentIDProjectFileFolder);
			if (!isValidFileName)
			{
				return;
			}
		}

		if (event)
		{
			if (event.currentTarget instanceof HTMLElement)
			{
				event.currentTarget.classList.add('is-loading');
			}
		}

		// map file object with correct db properties
		const tmpFile = {
			IDProject: this.AppData?.DocumentData?.ReportData?.IDProject,
			IDProjectFile: pIDProjectFile,
			Name: inputElement.val(),
		};

		await this.pict.providers.ProjectFileProvider.updateProjectFile(tmpFile, (/** @type {any} */ pResult) =>
		{
			this.pict.providers.UtilityProvider.removeAllLoadingClasses();
			this.pict.views.HeadlightPanels.toast({
				message: 'Project file name updated',
				type: 'is-success',
			});
			if (pResult)
			{
				$(`#${this.getFileNameDisplayID(pRowID)}`).text(newFileName.toString());
				inputElement.val(newFileName);
				this.setProjectFileNameInCurrentSearchResults(newFileName, pIDProjectFile);
			}
		});

		// Switch back to non-editing mode
		this.projectFileRenameSwitchMode(pRowID);
	}

	/**
	 * Handles the deletion of a project file.
	 * @param {string} pName - The name of the file to delete.
	 * @param {string} pIDProjectFile - The ID of the project file to delete.
	 * @param {Event} event - The event that triggered the delete action.
	 * @return {void}
	 */
	// @ts-ignore
	// @ts-ignore
	projectFileDelete(event, pName, pIDProjectFile)
	{
		// the body and footer templates for the delete modal
		const deleteModalBodyTemplate = /*html*/`
		<span id="DeleteModalBody">
			<div class="cell is-12">
				<div class="field">
					<p class="subtitle is-6 has-text-centered">Delete<strong> ${pName}</strong>?</p>
					<p class="subtitle is-6 has-text-centered">Please click button below to delete or close this modal.</p>
				</div>
			</div>
		</span>`;
		const deleteModalFooterTemplate = /*html*/`
		<div id="DeleteModalFooter" class="buttons is-right">
			<button class="button is-danger is-soft" type="button" title="Cancel Save" onclick="_Pict.fable.services.HeadlightModal.dismissModals()">
				<span class="icon">
					<i class="fas fa-fw fa-times" aria-hidden="true"></i>
				</span>
				<span>Cancel</span>
			</button>
			<button class="button is-danger" type="button" title="Delete Project File" onclick="_Pict.views.ProjectFileSearch.projectFileDeleteHandler(event, ${pIDProjectFile})">
				<span class="icon">
					<i class="fas fa-fw fa-copy" aria-hidden="true"></i>
				</span>
				<span>Delete</span>
			</button>
		</div>`;
		// the options for the edit modal
		const deleteModalOptions = {
			title: 'Delete Project File?',
			modalBodyTemplate: deleteModalBodyTemplate,
			modalFooterTemplate: deleteModalFooterTemplate,
			confirmText: 'Delete',
			cancelText: 'Cancel',
		};
		this.fable.HeadlightModal.spawnModal(deleteModalOptions, this.confirmDeleteCallback.bind(this));
	}

	/**
	 * Handles deleting project file
	 * @param {number} pIDProjectFile - The ID of the project file to delete.
	 * @param {Event} event - The event that triggered the save action.
	 * @return {Promise<void>}
	 * @async
	 */
	async projectFileDeleteHandler(event, pIDProjectFile)
	{
		if (event)
		{
			if (event.currentTarget instanceof HTMLElement)
			{
				event.currentTarget.classList.add('is-loading');
			}
		}

		await this.pict.providers.ProjectFileProvider.handleProjectFileDeletion(pIDProjectFile, (/** @type {any} */ pResult) =>
		{
			this.pict.providers.UtilityProvider.removeAllLoadingClasses();
			this.pict.views.HeadlightPanels.toast({
				message: 'Project File Deleted',
				type: 'is-success',
			});
			if (pResult)
			{
				this.handleProjectFileSearch(event, null, null);
			}
		});
		this.pict.fable.services.HeadlightModal.dismissModals();
	}

	/**
	 * Handles saving updated file type for project file
	 * @param {Event} event - The event that triggered the save action.
	 * @param {number} pFileID - The file object being saved.
	 * @param {string} pRowID - The ID of the row in the treeview.
	 * @return {Promise<void>}
	 * @async
	 */
	async projectFileSaveHandler(event, pFileID, pRowID, pFileName, pParentIDProjectFileFolder)
	{
		//save filename changes
		const tmpFileNameInput = /** @type {HTMLTextAreaElement} */ (document.getElementById(`ProjectFileSearch-Results-Treeview-List-File-Name-${pFileID}`));
		const newFileName = tmpFileNameInput.value;

		//compare newFileName to previous name and only check for existance or validity if it has changed.
		const hasFileNameChanged = pFileName !== newFileName;
		if (hasFileNameChanged)
		{
			const isValidFileName = this.isValidFileName(newFileName, pParentIDProjectFileFolder);
			if (!isValidFileName)
			{
				return;
			}
		}

		if (event)
		{
			if (event.currentTarget instanceof HTMLElement)
			{
				event.currentTarget.classList.add('is-loading');
			}
		}
		const tmpFileTypeSelect = /** @type {HTMLSelectElement} */ (document.getElementById(`ProjectFileSearch-Results-Treeview-List-File-Type-Select-${pFileID}`));
		const tmpFileType = tmpFileTypeSelect.value;
		const tmpCustomFileTypeInput = /** @type {HTMLInputElement} */ (document.getElementById(`ProjectFileSearch-Results-Treeview-List-File-Type-Custom-${pFileID}`));
		const tmpCustomFileType = tmpCustomFileTypeInput.value;

		// map file object with correct db properties
		const tmpFile = {
			IDProject: this.AppData?.DocumentData?.ReportData?.IDProject,
			IDProjectFile: pFileID,
			FileType: tmpFileType === 'Custom' ? tmpCustomFileType : tmpFileType,
			Name: newFileName,
		};

		await this.pict.providers.ProjectFileProvider.updateProjectFile(tmpFile, (/** @type {any} */ pResult) =>
		{
			this.pict.providers.UtilityProvider.removeAllLoadingClasses();
			this.pict.views.HeadlightPanels.toast({
				message: 'Project File Updated',
				type: 'is-success',
			});
			if (pResult)
			{
				this.handleProjectFileSearch(event, pRowID, true);
			}
		});
		this.pict.fable.services.HeadlightModal.dismissModals();
	}

	/**
	 * Add a new project folder.
	 * @param {Event} event - The event that triggered the function.
	 * @param {string} pName - The name of the folder.
	 * @param {string} pRowID - The ID of the row in the treeview.
	 * @return {void}
	 */
	// @ts-ignore
	// @ts-ignore
	projectRootFolderAddHandler(event, pName, pRowID)
	{
		// the body and footer templates for the confirmation modal
		const addRootFolderModalBodyTemplate = /*html*/`
		<span id="AddRootFolderModalBody">
			<div class="grid">
				<div class="cell is-6">
					<strong>Folder Name</strong>
					<input type="text input is-fullwidth" class="input mt-2"
		       			id="ProjectFileSearch-Results-Treeview-List-Folder-Name"
		       			placeholder="Enter folder name" />
				</div>
			</div>
		</span>`;
		const addRootFolderModalFooterTemplate = /*html*/`
		<div id="AddRootFolderModalFooter" class="buttons is-right">
			<button class="button is-primary is-soft" type="button" title="Cancel Save" onclick="_Pict.fable.services.HeadlightModal.dismissModals()">
				<span class="icon">
					<i class="fas fa-fw fa-times" aria-hidden="true"></i>
				</span>
				<span>Cancel</span>
			</button>
			<button class="button is-primary" type="button" title="Save Project Folder" onclick="_Pict.views.ProjectFileSearch.projectFolderSaveHandler(event, null, null, document.getElementById('ProjectFileSearch-Results-Treeview-List-Folder-Name').value, '${pRowID}')">
				<span class="icon">
					<i class="fas fa-fw fa-copy" aria-hidden="true"></i>
				</span>
				<span>Save</span>
			</button>
		</div>`;
		// the options for the edit modal
		const addRootFolderModalOptions = {
			title: 'Add Project Folder (root level)?',
			modalBodyTemplate: addRootFolderModalBodyTemplate,
			modalFooterTemplate: addRootFolderModalFooterTemplate,
			confirmText: 'Save',
			cancelText: 'Cancel',
		};
		this.fable.HeadlightModal.spawnModal(addRootFolderModalOptions, this.confirmSaveCallback.bind(this));
	}

	/**
	 * Add a new project folder.
	 * @param {Event} event - The event that triggered the function.
	 * @param {string} pName - The name of the folder.
	 * @param {number} pParentIDProjectFolder - The IDFile of the parent folder.
	 * @param {string} pRowID - The ID of the row in the treeview.
	 * @return {void}
	 */
	// @ts-ignore
	// @ts-ignore
	projectFolderAddHandler(event, pName, pParentIDProjectFolder, pRowID)
	{
		// the body and footer templates for the confirmation modal
		const addFolderModalBodyTemplate = /*html*/`
		<span id="AddFolderModalBody">
			<div class="grid">
				<div class="cell is-6">
					<label class="label" for="ProjectFileSearch-Results-Treeview-List-Folder-Name">Folder Name</label>
					<input type="text" class="input is-fullwidth mt-2"
		       			id="ProjectFileSearch-Results-Treeview-List-Folder-Name"
		       			placeholder="Enter folder name" />
				</div>
				<div class="cell is-6">
					<label class="label" for="ProjectFileSearch-Results-Treeview-List-Folder-Name-Parent">Parent Folder</label>
					<input type="text" class="input is-fullwidth is-static mt-2"
		       			id="ProjectFileSearch-Results-Treeview-List-Folder-Name-Parent"
						value="${pName}" />
				</div>
			</div>
		</span>`;
		const addFolderModalFooterTemplate = /*html*/`
		<div id="AddFolderModalFooter" class="buttons is-right">
			<button class="button is-primary is-soft" type="button" title="Cancel Save" onclick="_Pict.fable.services.HeadlightModal.dismissModals()">
				<span class="icon">
					<i class="fas fa-fw fa-times" aria-hidden="true"></i>
				</span>
				<span>Cancel</span>
			</button>
			<button class="button is-primary" type="button" title="Save Project Folder" onclick="_Pict.views.ProjectFileSearch.projectFolderSaveHandler(event, null, ${pParentIDProjectFolder}, document.getElementById('ProjectFileSearch-Results-Treeview-List-Folder-Name').value, '${pRowID}')">
				<span class="icon">
					<i class="fas fa-fw fa-copy" aria-hidden="true"></i>
				</span>
				<span>Save</span>
			</button>
		</div>`;
		// the options for the edit modal
		const addFolderModalOptions = {
			title: 'Add Project Folder (to parent folder)?',
			modalBodyTemplate: addFolderModalBodyTemplate,
			modalFooterTemplate: addFolderModalFooterTemplate,
			confirmText: 'Save',
			cancelText: 'Cancel',
		};
		this.fable.HeadlightModal.spawnModal(addFolderModalOptions, this.confirmSaveCallback.bind(this));
	}

	/**
	 * Edit a project folder name.
	 * @param {Event} event - The event that triggered the function.
	 * @param {string} pName - The name of the folder.
	 * @param {string} pIDProjectFileFolder - The ID of the folder.
	 * @param {string} pParentIDProjectFileFolder - The ID of the parent folder.
	 * @param {string} pRowID - The ID of the row in the treeview.
	 * @return {void}
	 */
	// @ts-ignore
	// @ts-ignore
	projectFolderEditHandler(event, pName, pIDProjectFileFolder, pParentIDProjectFileFolder, pRowID)
	{
		// the body and footer templates for the rename folder modal
		const renameFolderModalBodyTemplate = /*html*/`
		<span id="RenameFolderModalBody">
			<div class="grid">
				<div class="cell is-12">
					<label class="label" for="ProjectFileSearch-Results-Treeview-List-Folder-Name">Folder Name</label>
					<input type="text input is-fullwidth" class="input mt-2"
		       			id="ProjectFileSearch-Results-Treeview-List-Folder-Name"
						value="${pName}"
		       			placeholder="Enter folder name" />
				</div>
			</div>
		</span>`;
		const renameFolderModalFooterTemplate = /*html*/`
		<div id="RenameFolderModalFooter" class="buttons is-right">
			<button class="button is-primary is-soft" type="button" title="Cancel Save" onclick="_Pict.fable.services.HeadlightModal.dismissModals()">
				<span class="icon">
					<i class="fas fa-fw fa-times" aria-hidden="true"></i>
				</span>
				<span>Cancel</span>
			</button>
			<button class="button is-primary" 
					type="button" 
					title="Save Project Folder" 
					onclick="_Pict.views.ProjectFileSearch.projectFolderSaveHandler(event, '${pIDProjectFileFolder}', '${pParentIDProjectFileFolder}', document.getElementById('ProjectFileSearch-Results-Treeview-List-Folder-Name').value, '${pRowID}')">
				<span class="icon">
					<i class="fas fa-fw fa-copy" aria-hidden="true"></i>
				</span>
				<span>Save</span>
			</button>
		</div>`;
		// the options for the edit modal
		const renameFolderModalOptions = {
			title: 'Rename Project Folder?',
			modalBodyTemplate: renameFolderModalBodyTemplate,
			modalFooterTemplate: renameFolderModalFooterTemplate,
			confirmText: 'Save',
			cancelText: 'Cancel',
		};
		this.fable.HeadlightModal.spawnModal(renameFolderModalOptions, this.confirmSaveCallback.bind(this));
	}

	/**
	 * Callback to run when user confirms inspection type save
	 * @param {object} event - The click event
	 */
	async confirmSaveCallback(event)
	{
		if (event)
		{
			// render the current state of the project file panel
			this.pict.views.ProjectFileSearch.renderAsync(() =>
			{
				this.pict.log.info('Project File Panel Rendered');
			});
		}
	}

	/**
	 * Callback to run when user confirms inspection type save
	 * @param {object} event - The click event
	 */
	async confirmDeleteCallback(event)
	{
		if (event)
		{
			// render the current state of the project file panel
			this.pict.views.ProjectFileSearch.renderAsync(() =>
			{
				this.pict.log.info('Project File Panel Rendered');
			});
		}
	}

	/**
	 * Ensures a file name is unique among all files recursively under a given parent folder.
	 * Appends `_1`, `_2`, etc. if needed.
	 *
	 * @param {Array} folders - Array of root folder objects.
	 * @param {string} pNewFileName - Desired file name to insert.
	 * @param {any} pParentID - ID of the folder to start checking from (null/0 = root).
	 * @return {string} - A unique file name.
	 */
	checkFileNameExists(folders, pNewFileName, pParentID = null)
	{
		const nameRegex = /^(.*?)(\.[^.]*)?$/; // base + optional extension

		// Safer findParentNode
		function findParentNode(nodes, id)
		{
			if (!nodes || !Array.isArray(nodes)) return null;

			for (const node of nodes)
			{
				if (!node) continue; // skip undefined or null nodes
				if (node.ID === id) return node;
				if (node.Children && Array.isArray(node.Children) && node.Children.length > 0)
				{
					const found = findParentNode(node.Children, id);
					if (found) return found;
				}
			}
			return null;
		}

		let parentNode;
		if (!pParentID || parseInt(pParentID) === 0)
		{
			parentNode = { Children: folders }; // virtual root node
		}
		else
		{
			parentNode = findParentNode(folders, parseInt(pParentID));
			if (!parentNode) return pNewFileName;
		}

		function collectAllFileNames(node, resultSet)
		{
			if (!node || !node.Children || !Array.isArray(node.Children)) return;

			for (const child of node.Children)
			{
				if (!child) continue; // skip invalid
				if (child.IsFolder)
				{
					collectAllFileNames(child, resultSet);
				}
				else
				{
					if (child.Name)
					{
					resultSet.add(child.Name.toLowerCase());
					}
				}
			}
		}

		const existingNames = new Set();
		collectAllFileNames(parentNode, existingNames);

		if (!existingNames.has(pNewFileName.toLowerCase()))
		{
			return pNewFileName;
		}

		const match = pNewFileName.match(nameRegex);
		const base = match[1];
		const ext = match[2] || '';
		let counter = 1;
		let newName;

		do
		{
			newName = `${base}_${counter}${ext}`;
			counter++;
		} while (existingNames.has(newName.toLowerCase()));

		return newName;
	}


	/**
	 * Recursively checks if a folder name exists under a given parent folder node.
	 * @param {Array} folders - Array of root folders (tree structure).
	 * @param {string} pNewFolderName - Name to check.
	 * @param {any} pParentID - Parent folder ID to start from; null or 0 means root level.
	 * @return {boolean} True if folder name exists under that parent.
	 */
	checkFolderNameExists(folders, pNewFolderName, pParentID = null)
	{
		const lowerName = pNewFolderName.toLowerCase();

		// Safer findParent function
		const findParent = (nodes, id) =>
		{
			if (!nodes || !Array.isArray(nodes)) return null;

			for (const node of nodes)
			{
				if (!node) continue; // skip null/undefined nodes
				if (node.ID === id) return node;
				if (node.Children && Array.isArray(node.Children) && node.Children.length > 0)
				{
					const found = findParent(node.Children, id);
					if (found) return found;
				}
			}
			return null;
		};

		let parentNode;
		if (!pParentID || parseInt(pParentID) === 0)
		{
			parentNode = { Children: folders }; // virtual root node
		}
		else
		{
			parentNode = findParent(folders, parseInt(pParentID));
			if (!parentNode) return false; // parent not found
		}

		const checkChildren = (nodes) =>
		{
			if (!nodes || !Array.isArray(nodes)) return false;

			for (const node of nodes)
			{
				if (!node) continue; // skip invalid
				if (node.IsFolder && node.Name && node.Name.toLowerCase() === lowerName)
				{
					return true;
				}
			}
			return false;
		};

		// Only check immediate children of parent node
		return checkChildren(parentNode.Children);
	}


	/** Handles the addition of a project file.
	* @param {Event} event - The event that triggered the function.
	* @return {void}
	*/
	projectRootFileAddHandler(event)
	{
		if (event)
		{
			event.preventDefault();
			event.stopPropagation();
		}

		this.SelectedFileFolder = 0; // 0 indicates root folder
		this.pict.providers.ProjectFileProvider.openSearchPanel(this.pict.views.ProjectFileSearch, 'Project Files', 'add-to-root');
	}

	/** Handles the addition of a project file.
	* @param {Object} pIDObservation - The Observation object.
	* @param {Event} event - The event that triggered the function.
	* @return {void}
	*/

	/** Handles the addition of a project file.
	* @param {Event} event - The event that triggered the function.
	* @param {string} pName - The name of the project folder.
	* @param {number} pIDProjectFileFolder - The ID of the project folder.
	* @return {void}
	*/
	projectFileAddHandler(event, pName, pIDProjectFileFolder)
	{
		if (event)
		{
			event.preventDefault();
			event.stopPropagation();
		}

		this.SelectedFileFolder = pIDProjectFileFolder;
		this.SelectedFileFolderName = pName;
		this.pict.providers.ProjectFileProvider.openSearchPanel(this.pict.views.ProjectFileSearch, 'Project Files', 'add-to-folder');
	}

	/** Handles the addition of a project file.
	* @param {Object} pIDObservation - The Observation object.
	* @param {Event} event - The event that triggered the function.
	* @return {void}
	*/

	addObservationToProjectFolderRecord(pIDObservation, event)
	{
		if (event)
		{
			event.preventDefault();
			event.stopPropagation();
		}

		if (!pIDObservation || !pIDObservation.IDObservation)
		{
			this.pict.views.HeadlightPanels.toast({
				message: 'No observation selected to add to project folder',
				type: 'is-danger',
			});
			return;
		}

		let checkFileName = '';
		if (pIDObservation?.Details?.Image?.Datum?.FileName)
		{
			checkFileName = pIDObservation?.Details?.Image?.Datum?.FileName;
		}
		else if (pIDObservation?.Name)
		{
			checkFileName = pIDObservation?.Name;
		}

		const updatedFileName = this.checkFileNameExists(this.CurrentSearchResults, checkFileName, this.SelectedFileFolder);

		this.pict.log.info('Adding observation to project folder record:', pIDObservation, this.SelectedFileFolder);
		// map file object with correct db properties
		const tmpFile = {
			IDProject: this.AppData?.DocumentData?.ReportData?.IDProject,
			IDProjectFile: 0,
			IDObservation: pIDObservation.IDObservation,
			IDProjectFileFolder: this.SelectedFileFolder,
			Name: updatedFileName || pIDObservation.Name,
			FileType: pIDObservation.ObservationType,
		};
		this.pict.providers.ProjectFileProvider.addProjectFile(tmpFile, (/** @type {{ IDProjectFile: any; IDObservation: any; }} */ pResult) =>
		{
			this.pict.providers.UtilityProvider.removeAllLoadingClasses();
			this.pict.views.HeadlightPanels.toast({
				message: 'Project File Added',
				type: 'is-success',
			});
			if (pResult)
			{
				const _RowID = `File-${pResult.IDProjectFile}_${pResult.IDObservation}`;
				this.handleProjectFileSearch(event, _RowID, true);
			}
		});
	}

	/**
	 * Handles saving updated file type for project file
	 * @param {Event} event - The event that triggered the save action.
	 * @param {string} pIDProjectFileFolder - The ID of the project folder.
	 * @param {string} pParentIDProjectFileFolder - The ID of the parent project folder.
	 * @param {string} pNewFolderName - The name of the new folder.
	 * @param {string} pRowID - The ID of the row in the treeview.
	 * @return {Promise<void>}
	 * @async
	 */
	async projectFolderSaveHandler(event, pIDProjectFileFolder, pParentIDProjectFileFolder, pNewFolderName, pRowID)
	{
		const existingFolderName = this.checkFolderNameExists(this.CurrentSearchResults, pNewFolderName, pParentIDProjectFileFolder);

		if (existingFolderName)
		{
			this.pict.views.HeadlightPanels.toast({
				message: 'A folder with this name already exists',
				type: 'is-danger',
			});
			return;
		}

		if (event)
		{
			if (event.currentTarget instanceof HTMLElement)
			{
				event.currentTarget.classList.add('is-loading');
			}
		}

		// safe guard for no changes to save
		// todo: add disable flag to button that re-evals until something changes
		if (!pIDProjectFileFolder && !pParentIDProjectFileFolder && !pNewFolderName)
		{
			return;
		}

		// if we're renaming the folder, update the row ID to match the new name
		if (pIDProjectFileFolder)
		{
			pRowID = `${pNewFolderName.trim().replace(/['"]/g, '_').replace(/ /g, '_')}_${pIDProjectFileFolder}`;
		}

		if (pIDProjectFileFolder)
		{
			// map folder object with correct db properties
			const tmpFolder = {
				IDProject: this.AppData?.DocumentData?.ReportData?.IDProject,
				IDProjectFileFolder: parseInt(pIDProjectFileFolder),
				Name: pNewFolderName.replace(/['"]/g, '_'),
			};
			await this.pict.providers.ProjectFileProvider.updateProjectFolder(tmpFolder, (/** @type {any} */ pResult) =>
			{
				this.pict.providers.UtilityProvider.removeAllLoadingClasses();
				this.pict.views.HeadlightPanels.toast({
					message: 'Project Folder Updated',
					type: 'is-success',
				});
				if (pResult)
				{
					this.handleProjectFileSearch(event, pRowID, false);
				}
			});
			this.pict.fable.services.HeadlightModal.dismissModals();
			return;
		}
		else if (pParentIDProjectFileFolder)
		{
			// map folder object with correct db properties
			const tmpFolder = {
				IDProject: this.AppData?.DocumentData?.ReportData?.IDProject,
				IDProjectFileFolder: 0,
				ParentIDProjectFileFolder: parseInt(pParentIDProjectFileFolder),
				Name: pNewFolderName.replace(/['"]/g, '_'),
			};

			await this.pict.providers.ProjectFileProvider.addProjectFolder(tmpFolder, (/** @type {{ IDProjectFileFolder: any; }} */ pResult) =>
			{
				this.pict.providers.UtilityProvider.removeAllLoadingClasses();
				this.pict.views.HeadlightPanels.toast({
					message: 'Project Folder Added',
					type: 'is-success',
				});
				// if we're creating a new folder, update the row ID to match the new name
				pRowID = `${pNewFolderName.trim().replace(/['"]/g, '_').replace(/ /g, '_')}_${pResult.IDProjectFileFolder}`;
				if (pResult)
				{
					this.handleProjectFileSearch(event, pRowID, false);
				}
			});
		}
		else if (!pParentIDProjectFileFolder && !pIDProjectFileFolder)
		{
			// map folder object with correct db properties
			const tmpFolder = {
				IDProject: this.AppData?.DocumentData?.ReportData?.IDProject,
				IDProjectFileFolder: 0,
				ParentIDProjectFileFolder: 0,
				Name: pNewFolderName.replace(/['"]/g, '_'),
			};

			await this.pict.providers.ProjectFileProvider.addProjectFolder(tmpFolder, (/** @type {{ IDProjectFileFolder: any; }} */ pResult) =>
			{
				this.pict.providers.UtilityProvider.removeAllLoadingClasses();
				this.pict.views.HeadlightPanels.toast({
					message: 'Project Folder Added',
					type: 'is-success',
				});
				// if we're creating a new folder, update the row ID to match the new name
				pRowID = `${pNewFolderName.trim().replace(/['"]/g, '_').replace(/ /g, '_')}_${pResult.IDProjectFileFolder}`;
				if (pResult)
				{
					this.handleProjectFileSearch(event, pRowID, false);
				}
			});
		}
		this.pict.fable.services.HeadlightModal.dismissModals();
	}

	/**
	 * Renders the file type options for a select dropdown.
	 * Ensures the selectedTypeID is always included, even if it's not in the default list.
	 * @param {string} selectedTypeID - The ID of the currently selected file type.
	 * @return {string} The HTML string for the file type options.
	 */
	renderFileTypeOptions(selectedTypeID)
	{
	/** @type {{ id: string, text: string }[]} */
		let options = this.FileTypes;

		// Check if selectedTypeID exists in the options list
		const selectedExists = options.some((opt) => opt.id === selectedTypeID);

		// If it doesn't exist, add a custom option for it
		if (!selectedExists && selectedTypeID)
		{
			options = [
				...options,
				{ id: selectedTypeID, text: `${selectedTypeID}` },
			];
		}

		return options.map((opt) =>
		{
			const isSelected = opt.id === selectedTypeID ? 'selected' : '';
			const isDisabled = opt.id === '' ? 'disabled selected' : '';
			return `
			<option value="${opt.id}" id="${opt.id}" ${isSelected} ${isDisabled}>
				${opt.text}
			</option>`;
		}).join('');
	}


	/**
	 * Toggle the visibility of Project File Folder
	 * @param {*} event - the event object
	 * @param {string} _RowID - the name and id of the folder
	 * @return {void}
	 */
	toggleSectionVisibility(event, _RowID)
	{
		// find the icon in the button and swap it out
		const tmpIcon = event?.currentTarget?.querySelector('i') || event?.parentElement?.currentTarget?.querySelector('i');
		if (!tmpIcon)
		{
			return;
		}
		if (tmpIcon.classList.contains('fa-folder-open'))
		{
			tmpIcon.classList.remove('fa-folder-open');
			tmpIcon.classList.add('fa-folder-closed');
		}
		else
		{
			tmpIcon.classList.remove('fa-folder-closed');
			tmpIcon.classList.add('fa-folder-open');
		}
		// toggle the visibility of the child folders
		const tmpElementID = `ProjectFileSearch-Results-Treeview-Child-${_RowID}`;
		// if the element is not found, return
		if (!document.getElementById(tmpElementID))
		{
			this.log.error(`Element with ID ${tmpElementID} not found`);
			return;
		}
		document.getElementById(tmpElementID)?.classList.toggle('is-hidden', document.getElementById(tmpElementID)?.classList.contains('is-hidden') ? false : true);
	}

	/**
	 * Toggle the visibility of all sections
	 * @param {*} pVisibility - the visibility to set
	 * @return {void}
	 */
	toggleAllSectionVisibility(pVisibility)
	{
		const tmpSections = document.querySelectorAll('.panel-block-group');
		tmpSections.forEach((section) =>
		{
			if (pVisibility === 'open')
			{
				section.classList.remove('is-hidden');
			}
			else
			{
				section.classList.add('is-hidden');
			}
		});
		const tmpIcons = document.querySelectorAll('.panel-block-group-header i');
		tmpIcons.forEach((icon) =>
		{
			if (icon.classList.contains('fa-folder-open') && pVisibility === 'close')
			{
				icon.classList.remove('fa-folder-open');
				icon.classList.add('fa-folder-closed');
			}
			else
			{
				icon.classList.remove('fa-folder-closed');
				icon.classList.add('fa-folder-open');
			}
		});
	}

	//-----TODO: Extract into it's own provider once nailed down and make dynamic ------ BEGINNING

	/**
	 * Add a dropdown menu to the toggle button for a file row.
	 * @param {string} id - The ID of the file.
	 * @param {string} pRowID - The ID of the row.
	 * @param {string} pDate - The date of the file.
	 * @param {string} pName - The name of the file.
	 * @param {string} pFileID - The ID of the file.
	 * @param {string} pFileType - The type of the file.
	 */
	handleFileActionPopover(id, pRowID, pDate, pName, pFileID, pFileType)
	{
		const tmpMenuElement = document.getElementById(`PANEL-MENU-BUTTON-FOR-FILE-${pRowID}`);
		if (!tmpMenuElement)
		{
			this.pict.log.error(`Element with ID ${tmpMenuElement} not found for file menu`);
			return;
		}

		const popoverConfiguration = {
			PopoverTemplateHash: 'ProjectFileSearch-Results-Treeview-File-ActionMenu',
			PopoverDestinationAddress: id,
			PopoverTemplateRecord:
			{
				Date: pDate,
				Name: pName,
				ID: pFileID,
				Type: pFileType,
				_RowID: pRowID,
			},
			theme: 'dropdown-dark',
		};
		// create the popover menu
		this.fable.HeadlightPopover.createPopover(popoverConfiguration);
	}

	/**
	 * Add a dropdown menu to the toggle button for a file row.
	 * @param {string} id - The ID of the file.
	 * @param {string} pRowID - The ID of the row.
	 * @param {string} pName - The name of the folder.
	 * @param {string} pIDProjectFileFolder - The ID of the folder.
	 * @param {string} pParentIDProjectFileFolder - The ID of the parent folder.
	 */
	handleFolderActionPopover(id, pRowID, pName, pIDProjectFileFolder, pParentIDProjectFileFolder)
	{
		const tmpMenuElement = document.getElementById(`PANEL-MENU-BUTTON-FOR-FOLDER-${pRowID}`);
		if (!tmpMenuElement)
		{
			this.pict.log.error(`Element with ID ${tmpMenuElement} not found for folder menu`);
			return;
		}

		const popoverConfiguration = {
			PopoverTemplateHash: 'ProjectFileSearch-Results-Treeview-Folder-ActionMenu',
			PopoverDestinationAddress: id,
			PopoverTemplateRecord:
			{
				Name: pName,
				ID: pIDProjectFileFolder,
				ParentFolder: pParentIDProjectFileFolder,
				_RowID: pRowID,
			},
			theme: 'dropdown-dark',
		};
		// create the popover menu
		this.fable.HeadlightPopover.createPopover(popoverConfiguration);
	}

	/**
	 * Add a dropdown menu to the toggle button for a file row.
	 * @param {string} id - The ID of the file.
	 * @param {string} pRowID - The ID of the row.
	 * @param {string} pName - The name of the folder.
	 * @param {string} pIDProjectFileFolder - The ID of the folder.
	 */
	handleRootActionPopover(id, pRowID, pName, pIDProjectFileFolder)
	{
		const tmpMenuElement = document.getElementById(`PANEL-MENU-BUTTON-FOR-ROOT-${pRowID}`);
		if (!tmpMenuElement)
		{
			this.pict.log.error(`Element with ID ${tmpMenuElement} not found for root menu`);
			return;
		}

		const popoverConfiguration = {
			PopoverTemplateHash: 'ProjectFileSearch-Results-Treeview-Root-ActionMenu',
			PopoverDestinationAddress: id,
			PopoverTemplateRecord:
			{
				Name: pName,
				ID: pIDProjectFileFolder,
				_RowID: pRowID,
			},
			theme: 'dropdown-dark',
		};
		// create the popover menu
		this.fable.HeadlightPopover.createPopover(popoverConfiguration);
	}

	//-----TODO: Extract into it's own provider once nailed down and make dynamic ------ END
}

module.exports = ProjectFileSearch;

module.exports.default_configuration =
{
	ViewIdentifier: 'ProjectFileSearch',
	DefaultRenderable: 'ProjectFileSearch-Wrapper',
	DefaultDestinationAddress: '#HeadlightPanels-RightPanel',
	Templates:
		[
			{
				Hash: 'ProjectFileSearch-Wrapper',
				Template: /*html*/`
				<article id="HeadlightPanels-ProjectFileSearchPanel" class="panel is-active panel-content panel-has-nested-scroll-content">
					<p id="HeadlightPanels-ProjectFileSearchPanel-Observation-Header" class="panel-heading pr-4">
						<button type="button" class="is-pulled-right hl-panel-close-button" aria-label="close" title="Close panel" onclick="_Pict.views.HeadlightPanels.closeThisPanel(event)">
							<span class="icon">
								<i class="fas fa-fw fa-times-circle" aria-hidden="true"></i>
							</span>
						</button>
						<button type="button" class="is-pulled-right hl-panel-pin-button mr-2" aria-label="pin" title="Pin content" onclick="_Pict.views.HeadlightPanels.togglePanelPinState('right')">
							<span class="icon">
								<i class="fas fa-fw fa-thumbtack" aria-hidden="true"></i>
							</span>
						</button>
						<span class="icon">
							<i id="HeadlightPanels-ProjectFileSearchPanel-Observation-Header-Icon" class="fas fa-fw fa-files" aria-hidden="true"></i>
						</span>
						<span id="HeadlightPanels-ProjectFileSearchPanel-Observation-Header-Title" class="mr-3">Project Files</span>
					</p>
					<div class="panel-content nested-scroll-content">
						<div id="HeadlightPanels-ProjectFileSearch-Entry">
							{~T:ProjectFileSearch-Entry~}
						</div>
						<div id="HeadlightPanels-ProjectFileSearch-Content" class="has-bottom-navbar-offset">
							{~T:ProjectFileSearch-Project-Container~}
							{~T:ProjectFileSearch-Results~}
						</div>
					</div>
				</article>`,
			},
			{
				Hash: 'ProjectFileSearch-Entry',
				Template: /*html*/`
				<div id="ProjectFileSearch-SearchEntry" class="container">
					<form autocomplete="off" role="observation-search" onsubmit="_Pict.views.ProjectFileSearch.handleProjectFileSearch(event, null, null);">
						<div class="px-4 pt-4" data-collapsible-content="ProjectFileSearchFilters">
							<div class="columns is-hidden">
								{~T:ProjectFileSearch-Entry-CurrentPage~}
								{~T:ProjectFileSearch-Entry-PageSize~}
							</div>
							<div class="columns">
								{~T:ProjectFileSearch-Entry-ProjectSelector~}
							</div>
							<div class="columns">
								{~T:ProjectFileSearch-Entry-SearchText~}
							</div>
							<div class="columns">
								{~T:ProjectFileSearch-Entry-SearchFolder~}
							</div>
						</div>
						<div class="buttons m-3 mb-5" data-theme="dark">
							<button
								type="button"
								class="button is-primary" 
								title="Add Folder" 
								onclick="_Pict.views.ProjectFileSearch.projectRootFolderAddHandler(event, '{~D:Record.Name~}', '{~D:Record._RowID~}')">
								<span class="icon">
									<i class="fa fa-fw fa-folder-plus"></i>
								</span>
								<span class="icon-text">Add Folder</span>
							</button>
							<button
								type="button" 
								class="button is-primary" 
								title="Add File" 
								onclick="_Pict.views.ProjectFileSearch.projectRootFileAddHandler(event)">
								<span class="icon">
									<i class="fa fa-fw fa-file-plus"></i>
								</span>
								<span class="icon-text">Add File</span>
							</button>
							<button 
								type="button"
								id="ProjectFileSearch-ToggleButton"
								class="button is-primary is-soft" 
								title="Open search panel" 
								data-collapsible-toggle="ProjectFileSearchFilters" 
								onclick="_Pict.views.HeadlightPanels.toggleCollapsiblePanelBlockGroup('ProjectFileSearchFilters')">
								<span class="icon">
									<i class="fas fa-fw fa-filter"></i>
								</span>
								<span class="icon-text">Set Filters</span>
							</button>
							<button 
								type="button"
								class="button is-primary is-soft" 
								title="Reset filters" 
								id="ProjectFileSearch-ResetButton" 
								onclick="_Pict.views.ProjectFileSearch.resetSearchFilters()">
								<span class="icon">
									<i class="fas fa-fw fa-undo mr-1"></i>
								</span>
								<span class="icon-text">Clear Filters</span>
							</button>
							<button
								type="submit" 
								id="ProjectFileSearch-SearchButton"
								class="button is-primary" 
								title="Search project files">
								<span class="icon">
									<i class="fas fa-fw fa-search mr-1"></i>
								</span>
								<span class="icon-text">Search Project Files</span>
							</button>
						</div>
					</form>
				</div>`,
			},
			{
				Hash: 'ProjectFileSearch-Entry-ActiveFilterCount',
				Template: /*html*/`{~D:Context[0].CurrentSearchFiltersCount~}`,
			},
			{
				Hash: 'ProjectFileSearch-Entry-CurrentPage',
				Template: /*html*/`
				<div class="column">
					<div class="field">
						<label class="label" for="ProjectFileSearch-CurrentPage" class="block">Current Page</label>
						<input 
							id="ProjectFileSearch-CurrentPage" 
							type="number" 
							class="input" 
							placeholder="1" 
							onchange="_Pict.views.ProjectFileSearch.updateSearchFilterValue('CurrentPage')" 
							value=""
						/>
					</div>
				</div>`,
			},
			{
				Hash: 'ProjectFileSearch-Entry-PageSize',
				Template: /*html*/`
				<div class="column">
					<div class="field">
						<label class="label" for="ProjectFileSearch-PageSize" class="block">Page Size</label>
						<input 
							id="ProjectFileSearch-PageSize" 
							type="number" 
							class="input" 
							placeholder="50" 
							onchange="_Pict.views.ProjectFileSearch.updateSearchFilterValue('PageSize')" 
							value=""
						/>
					</div>
				</div>`,
			},
			{
				Hash: 'ProjectFileSearch-Entry-ProjectSelector',
				Template: /*html*/`
				<div class="column">
					<div class="field">
						<label class="label block" for="ProjectFileSearch-Projects">Project</label>
						<div class="control select is-fullwidth">
							<select 
								id="ProjectFileSearch-Projects" 
								onchange="_Pict.views.ProjectFileSearch.updateSearchFilterValue('Projects');_Pict.views.ProjectFileSearch.handleProjectFileSearch(event, null, null);"
							></select>
						</div>
					</div>
				</div>`,
			},
			{
				Hash: 'ProjectFileSearch-Entry-SearchText',
				Template: /*html*/`
				<div class="column">
					<label class="label" for="ProjectFileSearch-SearchText" class="block">File Search</label>
					<input 
						id="ProjectFileSearch-SearchText"
						type="text"
						class="input" 
						placeholder="Enter any specific text to search"
						onchange="_Pict.views.ProjectFileSearch.updateSearchFilterValue('SearchText')" 
						value=""
					/>
				</div>`,
			},
			{
				Hash: 'ProjectFileSearch-Entry-SearchFolder',
				Template: /*html*/`
				<div class="column">
					<label class="label" for="ProjectFileSearch-SearchFolder" class="block">Folder Search</label>
					<input
						id="ProjectFileSearch-SearchFolder"
						type="text"
						class="input"
						placeholder="Enter the name of the folder to search"
						onchange="_Pict.views.ProjectFileSearch.updateSearchFilterValue('SearchFolder')"
						value=""
					/>
				</div>`,
			},
			{
				Hash: 'ProjectFileSearch-Results',
				Template: /*html*/`
				<div id="ProjectFileSearch-Results-Container" class="container table-container">
					{~TIfAbs:ProjectFileSearch-Results-Empty:Context[0]:Context[0].CurrentSearchResults.length^==^0~}
					{~TIfAbs:ProjectFileSearch-Results-Treeview-Container:Context[0]:Context[0].CurrentSearchResults.length^>^0~}
				</div>`,
			},
			{
				Hash: 'ProjectFileSearch-Results-Empty',
				Template: /*html*/`
				<div class="notification m-3 empty-message">
					<p class="has-text-centered">
						<span class="icon">
							<i class="fa fa-fw fa-info-circle"></i>
						</span>
						<span>We could not find any project files based on the current search criteria.</span>
					</p>
				</div>`,
			},
			{
				Hash: 'ProjectFileSearch-Results-Table',
				Template: /*html*/`
				<table class="table is-striped is-hoverable is-fullwidth has-sticky-table-header">
					<thead>
						<tr>
							<th>Type</th>
							<th>File Name</th>
							{~T:ProjectFileSearch-Results-Extra-Header~}
						</tr>
					</thead>
					<tbody id="ProjectFileSearch-ResultsEntries">
						{~TS:ProjectFileSearch-Results-Row:Record.CurrentSearchResults~}
					</tbody>
				</table>`,
			},
			{
				Hash: 'ProjectFileSearch-Results-Row',
				Template: /*html*/`
				<tr class="is-clickable">
					<td class="is-vcentered" onclick="_Pict.views.ProjectFileSearch.handleProjectFilesDetailsClick(event, '{~D:Record.IDObservation~}', 'ProjectFiles')" data-observation-id="{~D:Record.IDObservation~}">
						{~TIfAbs:ProjectFileSearch-Results-ProjectFileFolder-Empty:Record:Record.IDProjectFileFolder^==^0~}
						{~TIfAbs:ProjectFileSearch-Results-ProjectFileFolder:Record:Record.IDProjectFileFolder^>^0~}
					</td>
					<td class="is-vcentered" onclick="_Pict.views.ProjectFileSearch.handleProjectFilesDetailsClick(event, '{~D:Record.IDObservation~}', 'ProjectFiles')" data-observation-id="{~D:Record.IDObservation~}">{~D:Record.Name~}</td>
					{~T:ProjectFileSearch-Results-Extra-Row:Record~}
				</tr>`,
			},
			{
				Hash: 'ProjectFileSearch-Results-Extra-Header',
				Template: /*html*/``,
			},
			{
				Hash: 'ProjectFileSearch-Results-Extra-Row',
				Template: /*html*/``,
			},
			{
				Hash: 'ProjectFileSearch-Results-User',
				Template: /*html*/`{~D:Record.NameFirst~} {~D:Record.NameLast~}`,
			},
			{
				Hash: 'ProjectFileSearch-Results-Project',
				Template: /*html*/`{~D:Record.Name~}`,
			},
			{
				Hash: 'ProjectFileSearch-Results-ProjectFileFolder',
				Template: /*html*/`{~E:ProjectFileFolder^Record.IDProjectFileFolder^ProjectFileSearch-Results-ProjectFileFolder-Name^~}`,
			},
			/* ----- start Tree View ---- */
			{
				Hash: 'ProjectFileSearch-Results-Treeview-Container',
				Template: /*html*/`
				<div class="treeview treeview overflow-scroll-container-for-search-results nested-scroll-content has-bottom-navbar-offset">
					{~TS:ProjectFileSearch-Results-Treeview:Record.CurrentSearchResults~}
				</div>`,
			},
			/* ----- Tree View > first layer (results or empty check) ----- */
			{
				Hash: 'ProjectFileSearch-Results-Treeview',
				Template: /*html*/`
					{~T:ProjectFileSearch-Results-Treeview-Content:Record~}
				`,
			},
			/* ----- Tree View > second layer (empty) ----- */
			{
				Hash: 'ProjectFileSearch-Results-Treeview-Empty',
				Template: /*html*/`
				<div class="notification m-3 empty-message">
					<p class="has-text-centered">
						<span class="icon">
							<i class="fa fa-fw fa-info-circle"></i>
						</span>
						<span>We could not find any project files based on the current search criteria.</span>
					</p>
				</div>`,
			},
			/* ----- Tree View > second layer (search results processed list) ----- */
			{
				Hash: 'ProjectFileSearch-Results-Treeview-Content',
				Template: /*html*/`
				{~TIfAbs:ProjectFileSearch-Results-Treeview-File:Record:Record.IsFolder^==^0~}
				{~TIfAbs:ProjectFileSearch-Results-Treeview-FolderList:Record:Record.IsFolder^==^1~}`,
			},
			/* ----- Tree View > third layer (folder of files) ----- */
			{
				Hash: 'ProjectFileSearch-Results-Treeview-FolderList',
				Template: /*html*/`
				<div
					id="ProjectFileSearch-Results-Treeview-{~D:Record._RowID~}"
					class="panel-block panel-block-group-header is-relative is-clickable px-1 py-0" 
					onclick="_Pict.views.ProjectFileSearch.toggleSectionVisibility(event, '{~D:Record._RowID~}')">
					<a class="button is-ghost has-text-primary-60">
						<span class="icon">
							<i class="fa fa-fw fa-folder-open"></i>
						</span>
					</a>
					<h4 class="title is-size-6 label has-text-text-90">{~D:Record.Name~}</h4>
					{~T:ProjectFileSearch-Results-Treeview-Folder-Action-Button~}
				</div>
				<div id="ProjectFileSearch-Results-Treeview-Child-{~D:Record._RowID~}" class="is-hoverable is-hidden panel-block-group">
					{~TIfAbs:ProjectFileSearch-Results-Treeview-Folder-Content:Record:Record.Children.length^>^0~}
					{~TIfAbs:ProjectFileSearch-Results-Treeview-Folder-Empty:Record:Record.Children.length^==^0~}
				</div>`,
			},
			{
				Hash: 'ProjectFileSearch-Results-Treeview-File',
				Template: /*html*/`
				<div 
					id="ProjectFileSearch-Results-Treeview-Child-{~D:Record._RowID~}"
					class="panel-block is-file-row is-clickable py-2"
					title="View File Details" 
					onclick="_Pict.views.ProjectFileSearch.handleProjectFilesDetailsClick(event, '{~D:Record.IDObservation~}', 'ProjectFiles')" data-observation-id="{~D:Record.IDObservation~}"
					data-observation-id="{~D:Record.IDObservation~}"
				>
					<span class="icon has-text-primary-90">
						<i class="fa fa-fw fa-file"></i>
					</span>
					<span id="DISPLAY-FOR-{~D:Record._RowID~}" class="has-text-text-90">
						<span id="NAME-FOR-{~D:Record._RowID~}">
							{~D:Record.Name~}
						</span>
						{~T:ProjectFileSearch-Results-Treeview-File-Action-Button~}
					</span>
					<span id="EDIT-FOR-{~D:Record._RowID~}" class="is-hidden columns is-align-self-center" onclick="event.stopPropagation();">
						<span class="column is-three-fifths py-0">
							<input class="input is-normal" id="INPUT-FOR-{~D:Record._RowID~}" type="text" value="{~D:Record.Name~}" />
						</span>
						<span class="column is-align-content-center py-0">
							<button
								type="button"
								class="button is-small is-link is-soft is-outlined"
								onclick="_Pict.views.ProjectFileSearch.projectFileRenameSwitchMode('{~D:Record._RowID~}')"
								title="Cancel"
							>
								<i id="ObservationDetails-Content-Save-Icon" class="fas fa-fw fa-times"></i>
							</button>
							<button
								type="button"
								class="button is-small is-link"
								onclick="_Pict.views.ProjectFileSearch.projectFileRename(event, '{~D:Record.Name~}', '{~D:Record.ID~}', '{~D:Record.ParentFolder~}', '{~D:Record._RowID~}')"
								title="Save"
							>
								<i class="fa fa-fw fa-save"></i>
							</button>
						</span>
					</span>
				</div>`,
			},
			{
				Hash: 'ProjectFileSearch-Results-Treeview-File-Action-Button',
				Template: /*html*/`
				<button
                    id="PANEL-MENU-BUTTON-FOR-FILE-{~D:Record._RowID~}"
                    class="button icon-button is-ghost has-text-primary-60 p-0 ml-3"
					style="float: none"
					title="Actions"
                    type="button"
                    aria-haspopup="true"
                    onmouseover="_Pict.views.ProjectFileSearch.handleFileActionPopover(id, '{~D:Record._RowID~}', '{~D:Record.Date~}', '{~D:Record.Name~}', '{~D:Record.ID~}', '{~D:Record.Type~}')"
                    onclick="_Pict.views.ProjectFileSearch.handleFileActionPopover(id, '{~D:Record._RowID~}', '{~D:Record.Date~}', '{~D:Record.Name~}', '{~D:Record.ID~}', '{~D:Record.Type~}'); event.stopPropagation();">
                    <span class="icon is-small">
                        <i class="fas fa-circle-ellipsis" aria-hidden="true"></i>
                    </span>
                </button>`,
			},
			{
				Hash: 'ProjectFileSearch-Results-Treeview-File-ActionMenu',
				Template: /*html*/`
				<ul class="list-menu visible-mode_{~D:Pict.views.ProjectFileSearch.SearchPanelMode~}">
					<li class="list-menu-item mode_project-file">
						<a class="move-table-row-down-button" onclick="_Pict.views.ProjectFileSearch.projectFileEditHandler(event, '{~DateFormat:Record.Date^YYYY-MM-DD - HH:mm a~}', '{~D:Record.Name~}', '{~D:Record.ID~}', '{~D:Record._RowID~}', '{~D:Record.Type~}', '{~D:Record.ParentFolder~}')">
							<span class="icon">
								<i class="fas fa-pencil"></i>
							</span>
							<span>Edit</span>
						</a>
					</li>
					<li class="list-menu-item mode_project-file">
						<a class="delete-table-row-button" onclick="_Pict.views.ProjectFileSearch.projectFileDelete(event, '{~D:Record.Name~}', '{~D:Record.ID~}')">
							<span class="icon">
								<i class="fas fa-trash"></i>
							</span>
							<span>Delete</span>
						</a>
					</li>
					<li class="list-menu-item mode_project-file">
						<a class="delete-table-row-button" onclick="_Pict.views.ProjectFileSearch.projectFileRenameSwitchMode('{~D:Record._RowID~}')">
							<span class="icon">
								<i class="fas fa-pen-field"></i>
							</span>
							<span>Rename File</span>
						</a>
					</li>
				</ul>`,
			},
			{
				Hash: 'ProjectFileSearch-Results-Treeview-Folder-Action-Button',
				Template: /*html*/`
				<button
                    id="PANEL-MENU-BUTTON-FOR-FOLDER-{~D:Record._RowID~}"
                    class="button icon-button is-ghost has-text-primary-60 p-0 ml-3"
					style="float: none"
					title="Actions"
                    type="button"
                    aria-haspopup="true"
                    onmouseover="_Pict.views.ProjectFileSearch.handleFolderActionPopover(id, '{~D:Record._RowID~}', '{~D:Record.Name~}', '{~D:Record.ID~}', '{~D:Record.ParentFolder~}')"
                    onclick="_Pict.views.ProjectFileSearch.handleFolderActionPopover(id, '{~D:Record._RowID~}', '{~D:Record.Name~}', '{~D:Record.ID~}', '{~D:Record.ParentFolder~}')">
                    <span class="icon is-small">
                        <i class="fas fa-circle-ellipsis" aria-hidden="true"></i>
                    </span>
                </button>`,
			},
			{
				Hash: 'ProjectFileSearch-Results-Treeview-Folder-ActionMenu',
				Template: /*html*/`
				<ul class="list-menu visible-mode_{~D:Pict.views.ProjectFileSearch.SearchPanelMode~}">
					<li class="list-menu-item mode_project-folder">
                        <a class="move-table-row-down-button" onclick="_Pict.views.ProjectFileSearch.projectFileAddHandler(event, '{~D:Record.Name~}', '{~D:Record.ID~}')">
                            <span class="icon">
                                <i class="fas fa-file-plus"></i>
                            </span>
                            <span>Add File</span>
                        </a>
                    </li>
					<li class="list-menu-item mode_project-folder">
						<a class="move-table-row-down-button" onclick="_Pict.views.ProjectFileSearch.projectFolderAddHandler(event, '{~D:Record.Name~}', '{~D:Record.ID~}', '{~D:Record._RowID~}')">
							<span class="icon">
								<i class="fas fa-folder-plus"></i>
							</span>
							<span>Add Folder</span>
						</a>
					</li>
					<li class="list-menu-item mode_project-folder">
						<a class="delete-table-row-button" onclick="_Pict.views.ProjectFileSearch.projectFolderEditHandler(event, '{~D:Record.Name~}', '{~D:Record.ID~}', '{~D:Record.ParentFolder~}', '{~D:Record._RowID~}')">
							<span class="icon">
								<i class="fas fa-pencil"></i>
							</span>
							<span>Rename Folder</span>
						</a>
					</li>
				</ul>`,
			},
			{
				Hash: 'ProjectFileSearch-Results-Visibility-Buttons',
				Template: /*html*/`
				<div class="buttons mx-4 mb-0">
					<button type="button" class="button is-ghost has-text-primary-soft" title="Expand all" onclick="_Pict.views.ProjectFileSearch.toggleAllSectionVisibility('open')">
						<span class="icon">
							<i class="fa fa-fw fa-expand"></i>
						</span>
						<span class="icon-text">Expand All</span>
					</button>
					<button type="button" class="button is-ghost has-text-primary-soft" title="Collapse all" onclick="_Pict.views.ProjectFileSearch.toggleAllSectionVisibility('close')">
						<span class="icon">
							<i class="fa fa-fw fa-compress"></i>
						</span>
						<span class="icon-text">Collapse All</span>
					</button>
				</div>`,
			},
			{
				Hash: 'ProjectFileSearch-Results-Treeview-File-Type-Selector',
				Template: /*html*/`
                <p id="ProjectFileSearch-Results-Treeview-File-Type-Readonly-{~D:Record.ID~}">
					<span class="subtitle is-6 has-text-text-90">{~D:Record.Type~}</span>
				</p>
				<p id="ProjectFileSearch-Results-Treeview-File-Type-Edit-{~D:Record.FolderID~}" class="control select is-fullwidth is-relative is-hidden">
					<select 
						id="ProjectFileSearch-Results-Treeview-File-Type-Select-{~D:Record.ID~}"
						class="input mr-2"
						onchange="_Pict.views.ProjectFileSearch.handleFileTypeChange(event, '{~D:Record.ID~}')">
						{~TS:ProjectFileSearch-Results-Treeview-File-Type-Options:Context[0].Context[0].FileTypes~}
					</select>
					<input 
						type="text" 
						class="input mt-2 is-hidden"
		       			id="ProjectFileSearch-Results-Treeview-File-Type-Custom-{~D:Record.ID~}"
		       			placeholder="Enter custom file type" />
				</p>`,
			},
			{
				Hash: 'ProjectFileSearch-Results-Treeview-File-Type-Options',
				Template: /*html*/`<option value="{~D:Record.id~}">{~D:Record.text~}</option>`,
			},
			{
				Hash: 'ProjectFileSearch-Results-Treeview-Folder-Content',
				Template: /*html*/`
				<div class="treeview-folder">
					{~TS:ProjectFileSearch-Results-Treeview-Content:Record.Children~}
				</div>`,
			},
			{
				Hash: 'ProjectFileSearch-Results-Treeview-Folder-Empty',
				Template: /*html*/`
                <div class="notification mx-3 p-2 empty-message has-background-text-30">
					<p class="has-text-centered">
						<span class="icon">
							<i class="fa-regular fa-info-circle"></i>
						</span>
						<span class="icon-text">This folder is empty.</span>
					</p>
				</div>`,
			},
			// TODO: Project File Paths for Name: https://bridge.qa.headlight.com/1.0/ImportantProjectFiles/10337/ (which does one folder at a time)
			{
				Hash: 'ProjectFileSearch-Results-ProjectFileFolder-Name',
				Template: /*html*/`{~D:Record.Name~}`,
			},
			{
				Hash: 'ProjectFileSearch-Results-ProjectFileFolder-Empty',
				Template: /*html*/`/`,
			},
			{
				Hash: 'ProjectFileSearch-Project-Container',
				Template: /*html*/`
				<div id="ProjectFileSearch-Project-Container" class="columns has-background-text-20">
					<div id="ProjectFileSearch-Project-Selected" class="column is-hidden">
						<span class="title is-6 has-text-white ml-4">{~D:AppData.DocumentData.ReportData.Name~}</span>
					</div>
					<div id="ProjectFileSearch-Project-Empty" class="column is-hidden">
						{~T:ProjectFileSearch-Project-Empty~}
					</div>
					{~T:ProjectFileSearch-Results-Visibility-Buttons~}
				</div>`,
			},
			{
				Hash: 'ProjectFileSearch-Results-ProjectFiles-Root',
				Template: /*html*/`
				<div id="ProjectFileSearch-Results-ProjectFile-Root" class="column">
					{~TS:ProjectFileSearch-Results-ProjectFile-Root-Files:Record.Children~}
				</div>`,
			},
			{
				Hash: 'ProjectFileSearch-Results-ProjectFile-Root-Files',
				Template: /*html*/`
				<div id="ProjectFileSearch-Results-ProjectFile-Root-File-{~D:Record.IDProjectFile~}" class="column">
					{~D:Record.Name~}
				</div>`,
			},
			{
				Hash: 'ProjectFileSearch-Project-Empty',
				Template: /*html*/`<p class="title is-5 has-text-white" >No project selected. These are all the files you have access to.</p>`,
			},
			/* ----- end Tree View ----- */
		],
	Renderables:
		[
			{
				RenderableHash: 'ProjectFileSearch-Wrapper',
				TemplateHash: 'ProjectFileSearch-Wrapper',
				DefaultDestinationAddress: '#HeadlightPanels-LeftPanel',
			},
			{
				RenderableHash: 'ProjectFileSearch-Entry-ProjectSelector',
				TemplateHash: 'ProjectFileSearch-Entry-ProjectSelector',
				DestinationAddress: '#ProjectFileSearch-Entry-ProjectSelector',
			},
			{
				RenderableHash: 'ProjectFileSearch-Entry-ActiveFilterCount',
				TemplateHash: 'ProjectFileSearch-Entry-ActiveFilterCount',
				DestinationAddress: '#ProjectFileSearch-Entry-ActiveFilterCount',
			},
			{
				RenderableHash: 'ProjectFileSearch-Results',
				TemplateHash: 'ProjectFileSearch-Results',
				DestinationAddress: '#ProjectFileSearch-Results-Container',
			},
			{
				RenderableHash: 'ProjectFileSearch-Pagination',
				TemplateHash: 'ProjectFileSearch-Pagination',
				DestinationAddress: '#ProjectFileSearch-Pagination-Container',
			},
		],
};
